import { trackSatuEvent } from './satu-event-tracker'

// Track landing page view
export function trackLandingPageView(pageKey: string) {
  if (pageKey === 'ult-kemdikbud') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'HOMEPAGE',
    })
  } else if (pageKey === 'ult-prosedur-pelayanan-publik') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'Prosedur Pelayanan Publik',
    })
  } else if (pageKey === 'ult-prosedur-pelayanan-informasi') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'Prosedur Pelayanan Informasi',
    })
  } else if (pageKey === 'ult-prosedur-pengaduan') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'Prosedur Pelayanan Pengaduan Publik',
    })
  } else if (pageKey === 'ult-prosedur-tatap-muka') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'Prosedur Pelayanan Tatap Muka Daring',
    })
  } else if (pageKey === 'ult-faq') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'FAQ',
    })
  } else if (pageKey === 'ult-skm') {
    trackSatuEvent({
      activity_type: 'PAGE_VIEW',
      page_name: 'Survei Kepuasan Masyarakat',
    })
  }
}

// Auto-track button clicks with class js-button-click-tracker
export function initButtonClickTracking() {
  if (typeof window === 'undefined') return

  // Use event delegation for dynamically added buttons
  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement
    const button = target.closest('.js-button-click-tracker')

    if (button) {
      const activityType =
        button.getAttribute('data-activity-type') || 'BUTTON_CLICKED'
      const pageName = button.getAttribute('data-page-name') || 'HOMEPAGE'

      const pageLocation = button.getAttribute('data-page-location')
      const linkName = button.getAttribute('data-link-name')
      const section = button.getAttribute('data-section')
      const tahun = button.getAttribute('data-tahun')

      const additionalData: Array<{ key: string; value: string }> = []

      if (pageLocation) {
        additionalData.push({
          key: 'page_location',
          value: pageLocation,
        })
      }

      if (linkName) {
        additionalData.push({
          key: 'link_name',
          value: linkName,
        })
      }

      if (section) {
        additionalData.push({
          key: 'section',
          value: section,
        })
      }

      if (tahun) {
        additionalData.push({
          key: 'tahun',
          value: tahun,
        })
      }

      const trackingData: any = {
        activity_type: activityType,
        page_name: pageName,
      }

      if (additionalData.length > 0) {
        trackingData.additional_data = additionalData
      }

      trackSatuEvent(trackingData)

      // For external links and navigation, prevent default briefly to ensure tracking completes
      const href = button.getAttribute('href')
      const target = button.getAttribute('target') || '_self'
      if (
        href &&
        (href.startsWith('http') ||
          href.startsWith('tel:') ||
          href.startsWith('mailto:'))
      ) {
        event.preventDefault()
        // Small delay to allow sendBeacon to queue, then navigate
        setTimeout(() => {
          if (href.startsWith('http')) {
            window.open(href, target)
          } else if (href.startsWith('tel:')) {
            window.location.href = href
          }
        }, 50)
      }
    }
  })
}
